import _ from 'lodash';
import { ADMIN_CONTACT_PARTNER, ADMIN_CONTACT_SCHOOL } from '../constants/admin.contacts.constants';
import { ALL_SELECT_OPTION } from '../constants/settings.constants';

export const getCanSubmitContact = (data, validation, isEdit) => {
  const hasBasicRequiredFields = !!data?.firstName && !!data?.type && !!data?.lastName;
  const hasPartnerRequiredFields = !!data?.email && !data?.roles?.some((r) => !r?.treePath);
  const hasSchoolRequiredFields = !!data?.email && !data?.roles?.some((r) => !r?.treePath);
  const hasCityRequiredFields = !!data?.userName && (isEdit || !!data?.role);
  const hasNoValidationErrors = Object.values(validation).filter((x) => !!x).length === 0;
  return (
    hasNoValidationErrors &&
    hasBasicRequiredFields &&
    (data?.type === ADMIN_CONTACT_PARTNER
      ? hasPartnerRequiredFields
      : data?.type === ADMIN_CONTACT_SCHOOL
      ? hasSchoolRequiredFields
      : hasCityRequiredFields)
  );
};

export const getCanSubmitParterOrganization = (data = {}) => {
  return !!data?.organization;
};

export const getCanSubmitSchoolOrganization = (data = {}) => {
  return (
    !!data?.net &&
    !!data?.management &&
    (!!data?.community || data?.management === ALL_SELECT_OPTION.value) &&
    (!!data?.school || data?.community === ALL_SELECT_OPTION.value || data?.management === ALL_SELECT_OPTION.value) &&
    (!!data?.branch ||
      data?.school === ALL_SELECT_OPTION.value ||
      data?.community === ALL_SELECT_OPTION.value ||
      data?.management === ALL_SELECT_OPTION.value)
  );
};

export const rolesToOrganizationName = (roles = [], nameKey, contactType) => {
  if (!nameKey) {
    return '';
  }

  const shouldShowAllePlaceholder =
    contactType === ADMIN_CONTACT_SCHOOL &&
    ['netName', 'managementName', 'communityName', 'schoolName', 'branchName'].includes(nameKey);

  return (
    _.uniq(
      roles?.map((role) =>
        role?.parents?.[nameKey] ? role?.parents?.[nameKey] : shouldShowAllePlaceholder ? ALL_SELECT_OPTION.label : ''
      )
    )?.join(', ') ?? ''
  );
};

export const mapOrganizationRole = (data, type) => {
  const roleBody = { ..._.pick(data, ['id', 'index', 'function', 'role', 'isApproved']) };
  if (type === ADMIN_CONTACT_SCHOOL) {
    roleBody.netName = data?.netName;
    roleBody.managementName = data?.managementName ?? ALL_SELECT_OPTION.label;
    roleBody.communityName = data?.communityName ?? ALL_SELECT_OPTION.label;
    roleBody.schoolName = data?.schoolName ?? ALL_SELECT_OPTION.label;
    roleBody.branchName = data?.branchName ?? ALL_SELECT_OPTION.label;
    roleBody.treePath = [data?.net, data?.management, data?.community, data?.school, data?.branch]
      .filter((index) => !!index && index !== ALL_SELECT_OPTION.value)
      ?.join('#');
  } else {
    roleBody.organizationName = data?.organizationName;
    roleBody.treePath = data.organization;
  }

  return roleBody;
};
